import axios from "axios";
import { API_ROOT } from "../constants";
import { errorResponse, getAffiliate } from "../helpers";
import { trackEvent, E_CREATE_PRODUCT_VARIANT, EC_ACCOUNT, E_UPDATE_SHOP, E_UPDATE_PRODUCT, E_DELETE_PRODUCT, E_CREATE_PRODUCT, E_UPDATE_ORDER, E_CHANGE_ORDER_STATUS, E_CREATE_SHOP } from "../helpers/tracking";

export const GET_SHOP_START = "GET_SHOP_START";
export const GET_SHOP_SUCCESS = "GET_SHOP_SUCCESS";
export const GET_SHOP_FAIL = "GET_SHOP_FAIL";

export const UPDATE_SHOP_START = "UPDATE_SHOP_START";
export const UPDATE_SHOP_SUCCESS = "UPDATE_SHOP_SUCCESS";
export const UPDATE_SHOP_FAIL = "UPDATE_SHOP_FAIL";

export const CREATE_SHOP_START = "CREATE_SHOP_START";
export const CREATE_SHOP_SUCCESS = "CREATE_SHOP_SUCCESS";
export const CREATE_SHOP_FAIL = "CREATE_SHOP_FAIL";

export const GET_SHOP_PRODUCTS_START = "GET_SHOP_PRODUCTS_START";
export const GET_SHOP_PRODUCTS_SUCCESS = "GET_SHOP_PRODUCTS_SUCCESS";
export const GET_SHOP_PRODUCTS_FAIL = "GET_SHOP_PRODUCTS_FAIL";

export const GET_SHOP_ADDONS_START = "GET_SHOP_ADDONS_START";
export const GET_SHOP_ADDONS_SUCCESS = "GET_SHOP_ADDONS_SUCCESS";
export const GET_SHOP_ADDONS_FAIL = "GET_SHOP_ADDONS_FAIL";

export const GET_SHOP_ORDERS_START = "GET_SHOP_ORDERS_START";
export const GET_SHOP_ORDERS_SUCCESS = "GET_SHOP_ORDERS_SUCCESS";
export const GET_SHOP_ORDERS_FAIL = "GET_SHOP_ORDERS_FAIL";

export const UPDATE_SHOP_PRODUCT_START = "UPDATE_SHOP_PRODUCT_START";
export const UPDATE_SHOP_PRODUCT_SUCCESS = "UPDATE_SHOP_PRODUCT_SUCCESS";
export const UPDATE_SHOP_PRODUCT_FAIL = "UPDATE_SHOP_PRODUCT_FAIL";

export const UPDATE_SHOP_ORDER_START = "UPDATE_SHOP_ORDER_START";
export const UPDATE_SHOP_ORDER_SUCCESS = "UPDATE_SHOP_ORDER_SUCCESS";
export const UPDATE_SHOP_ORDER_FAIL = "UPDATE_SHOP_ORDER_FAIL";

export const DELETE_SHOP_PRODUCT_START = "DELETE_SHOP_PRODUCT_START";
export const DELETE_SHOP_PRODUCT_SUCCESS = "DELETE_SHOP_PRODUCT_SUCCESS";
export const DELETE_SHOP_PRODUCT_FAIL = "DELETE_SHOP_PRODUCT_FAIL";

export const CREATE_SHOP_PRODUCT_START = "CREATE_SHOP_PRODUCT_START";
export const CREATE_SHOP_PRODUCT_SUCCESS = "CREATE_SHOP_PRODUCT_SUCCESS";
export const CREATE_SHOP_PRODUCT_FAIL = "CREATE_SHOP_PRODUCT_FAIL";

export const CREATE_VARIANT_START = "CREATE_VARIANT_START";
export const CREATE_VARIANT_SUCCESS = "CREATE_VARIANT_SUCCESS";
export const CREATE_VARIANT_FAIL = "CREATE_VARIANT_FAIL";

export const UPDATE_SHOP_ADDON_START = "UPDATE_SHOP_ADDON_START";
export const UPDATE_SHOP_ADDON_SUCCESS = "UPDATE_SHOP_ADDON_SUCCESS";
export const UPDATE_SHOP_ADDON_FAIL = "UPDATE_SHOP_ADDON_FAIL";

export const DELETE_SHOP_ADDON_START = "DELETE_SHOP_ADDON_START";
export const DELETE_SHOP_ADDON_SUCCESS = "DELETE_SHOP_ADDON_SUCCESS";
export const DELETE_SHOP_ADDON_FAIL = "DELETE_SHOP_ADDON_FAIL";

export const CREATE_SHOP_ADDON_START = "CREATE_SHOP_ADDON_START";
export const CREATE_SHOP_ADDON_SUCCESS = "CREATE_SHOP_ADDON_SUCCESS";
export const CREATE_SHOP_ADDON_FAIL = "CREATE_SHOP_ADDON_FAIL";

export function getUserShop() {
	return function (dispatch, getState) {
		dispatch({
			type: GET_SHOP_START,
		});

		// Get the current token.
		const { session: { token } } = getState();

		axios.get(`${API_ROOT}/vendors/mine`, {
			headers: {
				Authorization: `Bearer ${token}`
			},
		}).then(res => res.data).then(shop => {

			dispatch({
				type: GET_SHOP_SUCCESS,
				shop
			});
		}).catch(error => {
			dispatch({
				type: GET_SHOP_FAIL,
				error: errorResponse(error)
			});
		})
	}
}

export function updateShop(changes) {
	return function (dispatch, getState) {
		dispatch({
			type: UPDATE_SHOP_START,
		});

		// Get the current token.
		const { session: { token } } = getState();

		axios.put(`${API_ROOT}/vendors/mine`, changes, {
			headers: {
				Authorization: `Bearer ${token}`,
				"Content-Type": changes instanceof FormData ?
					"multipart/form-data" : "application/json"
			},
		}).then(res => res.data).then(shop => {
			dispatch({
				type: UPDATE_SHOP_SUCCESS,
				shop
			});

			// Track events.
			const toIterate = changes instanceof FormData ?
				JSON.parse(changes.get("data")) : changes;
			Object.keys(toIterate).forEach(field => trackEvent(EC_ACCOUNT, E_UPDATE_SHOP, field));

		}).catch(error => {
			dispatch({
				type: UPDATE_SHOP_FAIL,
				error: errorResponse(error)
			});
		})
	}
}

export function getShopProducts() {
	return function (dispatch, getState) {
		dispatch({
			type: GET_SHOP_PRODUCTS_START,
		});

		// Get the current token.
		const { session: { token } } = getState();

		axios.get(`${API_ROOT}/products`, {
			headers: {
				Authorization: `Bearer ${token}`
			},
		}).then(res => res.data).then(products => {
			dispatch({
				type: GET_SHOP_PRODUCTS_SUCCESS,
				products
			});
		}).catch(error => {
			dispatch({
				type: GET_SHOP_PRODUCTS_FAIL,
				error: errorResponse(error)
			});
		});
	}
}

export function getShopAddOns() {
	return function (dispatch, getState) {
		dispatch({
			type: GET_SHOP_ADDONS_START,
		});

		// Get the current token.
		const { session: { token } } = getState();

		axios.get(`${API_ROOT}/add-ons`, {
			headers: {
				Authorization: `Bearer ${token}`
			},
		}).then(res => res.data).then(addOns => {

			dispatch({
				type: GET_SHOP_ADDONS_SUCCESS,
				addOns
			});
		}).catch(error => {
			dispatch({
				type: GET_SHOP_ADDONS_FAIL,
				error: errorResponse(error)
			});
		});
	}
}

export function updateShopProduct(productId, changes) {
	return function (dispatch, getState) {
		if (!productId) return;
		dispatch({
			type: UPDATE_SHOP_PRODUCT_START,
			productId
		});

		// Get the current token.
		const { session: { token } } = getState();

		axios.put(`${API_ROOT}/products/${productId}`, changes, {
			headers: {
				Authorization: `Bearer ${token}`,
				"Content-Type": changes instanceof FormData ?
					"multipart/form-data" : "application/json"
			},
		}).then(res => res.data).then(product => {
			dispatch({
				type: UPDATE_SHOP_PRODUCT_SUCCESS,
				product
			});
			// Track events.
			const toIterate = changes instanceof FormData ?
				JSON.parse(changes.get("data")) : changes;
			Object.keys(toIterate).forEach(field => trackEvent(EC_ACCOUNT, E_UPDATE_PRODUCT, field));
		}).catch(error => {
			dispatch({
				type: UPDATE_SHOP_PRODUCT_FAIL,
				productId,
				error: errorResponse(error)
			});
		});
	}
}

export function deleteShopProduct(productId) {
	return function (dispatch, getState) {
		dispatch({
			type: DELETE_SHOP_PRODUCT_START,
			productId
		});

		// Get the current token.
		const { session: { token } } = getState();

		axios.delete(`${API_ROOT}/products/${productId}`, {
			headers: {
				Authorization: `Bearer ${token}`
			},
		}).then(res => res.data).then(product => {
			dispatch({
				type: DELETE_SHOP_PRODUCT_SUCCESS,
				productId
			});
			// Track events.
			trackEvent(EC_ACCOUNT, E_DELETE_PRODUCT);
		}).catch(error => {
			dispatch({
				type: DELETE_SHOP_PRODUCT_FAIL,
				productId,
				error: errorResponse(error)
			});
		});
	}
}

export function createShopProduct(data) {
	return function (dispatch, getState) {
		dispatch({
			type: CREATE_SHOP_PRODUCT_START,
			data
		});

		// Get the current token.
		const { session: { token } } = getState();

		axios.post(`${API_ROOT}/products`, data, {
			headers: {
				Authorization: `Bearer ${token}`
			},
		}).then(res => res.data).then(product => {
			dispatch({
				type: CREATE_SHOP_PRODUCT_SUCCESS,
				product
			});
			// Track events.
			trackEvent(EC_ACCOUNT, E_CREATE_PRODUCT);
		}).catch(error => {
			dispatch({
				type: CREATE_SHOP_PRODUCT_FAIL,
				error: errorResponse(error)
			});
		});
	}
}

export function createVariant(productId, data, cb) {
	return function (dispatch, getState) {
		dispatch({
			type: CREATE_VARIANT_START,
			productId,
			data
		});

		// Get the current token.
		const { session: { token } } = getState();

		axios.post(`${API_ROOT}/products/${productId}/variants`, data, {
			headers: {
				Authorization: `Bearer ${token}`
			},
		}).then(res => res.data).then(variant => {
			dispatch({
				type: CREATE_VARIANT_SUCCESS,
				productId,
				variant
			});
			if (cb) cb();
			// Track events.
			trackEvent(EC_ACCOUNT, E_CREATE_PRODUCT_VARIANT);
		}).catch(error => {
			dispatch({
				type: CREATE_VARIANT_FAIL,
				productId,
				error: errorResponse(error)
			});
		});
	}
}

export function getShopOrders(params = {}, cb) {
	return function (dispatch, getState) {
		dispatch({
			type: GET_SHOP_ORDERS_START,
		});

		// Get the current token.
		const { session: { token } } = getState();

		axios.get(`${API_ROOT}/orders`, {
			headers: {
				Authorization: `Bearer ${token}`
			},
			params
		}).then(res => res.data).then(orders => {
			dispatch({
				type: GET_SHOP_ORDERS_SUCCESS,
				orders
			});
			if (cb) cb(orders);
		}).catch(error => {
			dispatch({
				type: GET_SHOP_ORDERS_FAIL,
				error: errorResponse(error)
			});
		});
	}
}

export function updateShopOrder(orderId, changes) {
	return function (dispatch, getState) {
		dispatch({
			type: UPDATE_SHOP_ORDER_START,
			orderId
		});

		// Get the current token.
		const { session: { token } } = getState();

		axios.put(`${API_ROOT}/orders/${orderId}`, changes, {
			headers: {
				Authorization: `Bearer ${token}`,
				"Content-Type": "application/json"
			},
		}).then(res => res.data).then(order => {
			dispatch({
				type: UPDATE_SHOP_ORDER_SUCCESS,
				order
			});
			// Track events.
			Object.keys(changes).forEach(field => {
				if (field === "status") {
					trackEvent(EC_ACCOUNT, E_CHANGE_ORDER_STATUS, changes[field]);
				} else {
					trackEvent(EC_ACCOUNT, E_UPDATE_ORDER, field);
				}
			});
		}).catch(error => {
			dispatch({
				type: UPDATE_SHOP_ORDER_FAIL,
				orderId,
				error: errorResponse(error)
			});
		});
	}
}

export function createShop(shopData, cb) {
	return function (dispatch, getState) {
		dispatch({
			type: CREATE_SHOP_START,
			shopData
		});

		// Get affiliate.
		const aa = getAffiliate();
		// Get the current token.
		const { session: { token } } = getState();

		axios.post(`${API_ROOT}/vendors`, shopData, {
			...(aa ? { params: { aa } } : {}),
			headers: {
				Authorization: `Bearer ${token}`,
				"Content-Type": shopData instanceof FormData ?
					"multipart/form-data" : "application/json"
			}
		}).then(res => res.data).then(shop => {
			dispatch({
				type: CREATE_SHOP_SUCCESS,
				shop
			});
			if (cb) cb(shop);
			// Track event.
			trackEvent(EC_ACCOUNT, E_CREATE_SHOP, `${shop.id}_${shop.slug}`);
		}).catch(error => {
			dispatch({
				type: CREATE_SHOP_FAIL,
				error: errorResponse(error)
			});
		});
	}
}

// ------------------- ADDONS ------------------------

export function updateShopAddOn(addOnId, changes) {
	return function (dispatch, getState) {
		if (!addOnId) return;
		dispatch({
			type: UPDATE_SHOP_ADDON_START,
			addOnId
		});

		// Get the current token.
		const { session: { token } } = getState();

		axios.put(`${API_ROOT}/add-ons/${addOnId}`, changes, {
			headers: {
				Authorization: `Bearer ${token}`,
				"Content-Type": changes instanceof FormData ?
					"multipart/form-data" : "application/json"
			},
		}).then(res => res.data).then(addOn => {
			dispatch({
				type: UPDATE_SHOP_ADDON_SUCCESS,
				addOn
			});
			// TODO event track
		}).catch(error => {
			dispatch({
				type: UPDATE_SHOP_ADDON_FAIL,
				addOnId,
				error: errorResponse(error)
			});
		});
	}
}

export function deleteShopAddOn(addOnId) {
	return function (dispatch, getState) {
		dispatch({
			type: DELETE_SHOP_ADDON_START,
			addOnId
		});

		// Get the current token.
		const { session: { token } } = getState();

		axios.delete(`${API_ROOT}/add-ons/${addOnId}`, {
			headers: {
				Authorization: `Bearer ${token}`
			},
		}).then(res => res.data).then(addOn => {
			dispatch({
				type: DELETE_SHOP_ADDON_SUCCESS,
				addOnId
			});
			// TODO track events
		}).catch(error => {
			dispatch({
				type: DELETE_SHOP_ADDON_FAIL,
				addOnId,
				error: errorResponse(error)
			});
		});
	}
}

export function createShopAddOn(data, cb) {
	return function (dispatch, getState) {
		dispatch({
			type: CREATE_SHOP_ADDON_START,
			data
		});

		// Get the current token.
		const { session: { token } } = getState();

		axios.post(`${API_ROOT}/add-ons`, data, {
			headers: {
				Authorization: `Bearer ${token}`
			},
		}).then(res => res.data).then(addOn => {
			dispatch({
				type: CREATE_SHOP_ADDON_SUCCESS,
				addOn
			});
			if (cb) cb(addOn);
			// TODO track events.
		}).catch(error => {
			dispatch({
				type: CREATE_SHOP_ADDON_FAIL,
				error: errorResponse(error)
			});
		});
	}
}